"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../../styled"));
var tokens_1 = require("../../../tokens");
var divider_1 = __importDefault(require("./divider"));
var automation_attribute_1 = __importDefault(require("../../../_helpers/automation-attribute"));
var container_styles_1 = __importDefault(require("../../../_helpers/container-styles"));
var FieldSet = function (props) { return (React.createElement(FieldSet.Element, __assign({}, automation_attribute_1.default('form.fieldset')),
    React.createElement(divider_1.default, null, props.label),
    props.children)); };
FieldSet.Element = styled_1.default.fieldset(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  border: none;\n  padding: 0;\n  &:not(:last-of-type) {\n    margin-bottom: ", ";\n  }\n"], ["\n  ", ";\n  border: none;\n  padding: 0;\n  &:not(:last-of-type) {\n    margin-bottom: ", ";\n  }\n"])), container_styles_1.default, tokens_1.spacing.xlarge);
FieldSet.displayName = 'Form Fieldset';
FieldSet.defaultProps = {
    label: 'Fieldset Label'
};
exports.default = FieldSet;
var templateObject_1;
//# sourceMappingURL=fieldset.js.map